module.exports = __webpack_public_path__ + "img/icon_phone_16.5bed136c.svg";